module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-02-89b31dff9d7dc2798460da16b5bf2fdf.svg";